<template>
  <div class="ad-featured" v-if="content.double_mpu || content.mpu || content.leaderboard_desktop || content.leaderboard_mobile">
    <div class="ad-title">advertising</div>
    <div class="ad-wrapper" > 
      <div class="mpu-ad" v-html="content.mpu"></div>
      <div class="leaderboard-ad" v-html="content.leaderboard_desktop"></div>
      <div class="billboard-ad" v-html="content.leaderboard_mobile"></div>      
    </div>
  </div>
</template>

<script>
export default {
  name: "AdFeatured",
  props: {
    content: Object
  }
};
</script>

<style lang="scss">
.ad-featured{
  margin: 25px 0 25px 0;
  width: 100%;
  .ad-title{
    margin-left: calc((100% - 970px) / 2);
    text-transform: uppercase;
    font-weight: 100;
    font-size: 12px;
    opacity: 0.5;
  }
  .ad-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    .mpu-ad {
      display: none;
    }
    .leaderboard-ad {
      display: none;
    }
    .billboard-ad {
      display: flex;
    }
  }
}
@media (max-width: 1422px) {
  .ad-featured{
    display: block!important;
    .ad-title{
      margin-left: calc((100% - 728px) / 2);
    }
    .ad-wrapper {
      max-width: 100%;
      .mpu-ad {
        display: none;
      }
      .leaderboard-ad {
        display: flex;
      }
      .billboard-ad {
        display: none;
      }
    }
  }
}
@media (max-width: $mobile) {
  .ad-featured{
    display: block;
    .ad-title{
      margin-left: calc((100% - 300px) / 2)!important;
    }
    .ad-wrapper {
      width: 100%; 
      .billboard-ad {
        display: none;
      }     
      .leaderboard-ad{
        display: none;
      }
      .mpu-ad {
        display: flex;
      }
    }
  }
}
</style>